// The one call every unlock path makes to record its report version: the body is built here,
// so no path can drop paid_via or send a language other than the one on screen.
import { api } from "@/lib/api";
import { getLocale } from "@/lib/i18n";

export const PAID_VIA = { credit: "credit", single: "single", promo: "promo" };

export const reportVersionBody = (projectId, paidVia) => ({
  project_id: projectId,
  paid_via: paidVia,
  language: getLocale(),
});

// Idempotent on the server (one version per project and buyer); failures stay non-fatal.
export const recordReportVersion = async (projectId, paidVia) => {
  if (!projectId || !PAID_VIA[paidVia]) return null;
  try {
    const { data } = await api.post("/report-versions/snapshot-on-unlock", reportVersionBody(projectId, paidVia));
    return data;
  } catch {
    return null;
  }
};

const waiting = new Set();
const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

// Card checkout: the confirmation can arrive after the checkout window closes. Wait until the
// transaction says the project is paid (project_paid === true), then record the version once.
export const recordReportVersionWhenPaid = async (txnId, projectId, paidVia, { attempts = 40, intervalMs = 1500 } = {}) => {
  if (!txnId || !projectId || waiting.has(txnId)) return null;
  waiting.add(txnId);
  try {
    for (let i = 0; i < attempts; i++) {
      try {
        const { data } = await api.get(`/payments/status/${txnId}`);
        if (data?.project_paid === true) return await recordReportVersion(data.project_id || projectId, paidVia);
        if (data?.payment_status === "paid" && data?.project_paid === false) return null;
      } catch { /* transaction not visible yet */ }
      await sleep(intervalMs);
    }
    return null;
  } finally {
    waiting.delete(txnId);
  }
};
